import React, { useEffect, useState } from "react";
import { LuCloudDownload, LuCloudUpload } from "react-icons/lu";
import "../../../assets/styles/ServiceStyles/AllServiceStyles/AllService.css";
import FiltersTable from "../../../components/modals/SeriveModals/AllServiceModals/FiltersTable";
import GroupByResponseTable from "../../../components/modals/SeriveModals/AllServiceModals/GroupByResponseTable";
import HighDemandEnquiriesBanner from "../../../components/modals/SeriveModals/AllServiceModals/Rfq Modals/HighDemandEnquiriesBanner";
import AllServicesActionsSection from '../../../components/modals/SeriveModals/AllServiceModals/AllServicesActionsSection'
import AllServicesTable from "../../../components/modals/SeriveModals/AllServiceModals/AllServicesTable";
import AllRfqTable from "../../../components/modals/SeriveModals/AllServiceModals/AllRfqTable";
import BulkExportAllServices from "../../../components/modals/SeriveModals/AllServiceModals/BulkExportAllServices";
import CreateRfqModal from "../../../components/modals/SeriveModals/AllServiceModals/Rfq Modals/CreateRfqModal";
import SavePopup from '../../../components/modals/SeriveModals/AllServiceModals/Rfq Modals/SavePopup'
import AllTrendingServicesTable from "../../../components/modals/SeriveModals/AllServiceModals/AllTrendingServicesTable";
import BulkImportServiceModal from "../../../components/modals/SeriveModals/AllServiceModals/BulkImportModal";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPenToSquare, faPlus, faRotate } from "@fortawesome/free-solid-svg-icons";

const AllServices = () => {
    const [showBulkImportAllProducts, setShowBulkImportAllProducts] = useState(false);
    const [showBulkExportAllProducts, setShowBulkExportAllProducts] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [rfqSelectedIds, setSelecteRfqdIds] = useState([]);
    const [successStatusUpdate, setSuccessStatusUpdate] = useState("");
    const [successRfq, setSuccessRfq] = useState("");
    const [columnSearch, setColumnSearch] = useState("");
    const [rfqcolumnSearch, setRfqColumnSearch] = useState("");
    const [groupByResponse, setGroupByResponse] = useState([]);
    const [trendingGroupByResponse, setTrendingGroupByResponse] = useState([]);
    const [filterDataResponse, SetFilterDataResponse] = useState([]);
    const [trendingFilterDataResponse, SetTrendingFilterDataResponse] = useState([]);
    const [ShowGroupByResponseAllProductTable, setShowGroupByResponseAllProductTable] = useState(false);
    const [ShowTrendingGroupByResponseAllProductTable, setShowTrendingGroupByResponseAllProductTable] = useState(false);
    const [ShowFilterResponseAllProductTable, setShowFilterResponseAllProductTable] = useState(false);
    const [ShowTrendingFilterResponseAllProductTable, setShowTrendingFilterResponseAllProductTable] = useState(false);
    const [showAllProductTable, setShowAllProductTable] = useState(true);
    const [showAllTrendingProductTable, setShowAllTrendingProductTable] = useState(true);
    const [refreshTable1, setRefreshTable1] = useState(false);
    const [refreshTable2, setRefreshTable2] = useState(false);
    const [refreshTable3, setRefreshTable3] = useState(false);
    const [showSavePopup, setShowSavePopup] = useState(false);
    const [updateRfq, setUpdateRfq] = useState(null);
    const [changeIcon, setChangeIcon] = useState(''); // "Edit","Save"
    const [activeTab, setActiveTab] = useState("all"); // "all", "trending", "highDemand"
    const [pageSize, setPageSize] = useState(20);

    const [showCreateEnquiresForm, setShowCreateEnquiresForm] = useState(false);

    const handleBulkImport = () => {
        setShowBulkImportAllProducts(true);
    };

    const handleBulkExport = () => {
        setShowBulkExportAllProducts(true);
    };

    const handleColumnsSelection = (columns) => {
        setSelectedColumns(columns);
    };

    const handleSelectedIds = (Ids) => {
        setSelectedIds(Ids);
    };

    const handleSelecteRfqdIds = (Ids) => {
        setSelecteRfqdIds(Ids);
    };

    const handleSuccess = () => {
        setSuccessStatusUpdate("success");
        setSelectedIds([])
    };

    const handleRfqSuccess = () => {
        setSuccessRfq("success");
    };

    const handleColumnSearch = (columnsearch) => {
        setColumnSearch(columnsearch);
    };

    const handleRfqColumSearch = (rfqcolumnsearch) => {
        setRfqColumnSearch(rfqcolumnsearch);
    };

    const handleGroupByResponse = (groupByResponse) => {
        if (groupByResponse) {
            setGroupByResponse(groupByResponse);
            setShowGroupByResponseAllProductTable(true);
            setShowAllProductTable(false)
        }
    };

    const handleTrendingGroupByResponse = (trendinggroupByResponse) => {
        if (trendinggroupByResponse) {
            setTrendingGroupByResponse(trendinggroupByResponse);
            setShowTrendingGroupByResponseAllProductTable(true);
            setShowAllTrendingProductTable(false)
        }
    };

    const handleRemoveGroupBy = () => {
        setShowGroupByResponseAllProductTable(false);
        setShowAllProductTable(true)
    };

    const handleTrendingRemoveGroupBy = () => {
        setShowTrendingGroupByResponseAllProductTable(false);
        setShowAllTrendingProductTable(true)
    };

    const handleFilterDataResponse = (filterdataresponse) => {
        if (filterdataresponse) {
            SetFilterDataResponse(filterdataresponse);
            setShowFilterResponseAllProductTable(true);
            setShowAllProductTable(false)
        }
    }

    const handleTrendingFilterDataResponse = (trendingfilterdataresponse) => {
        if (trendingfilterdataresponse) {
            SetTrendingFilterDataResponse(trendingfilterdataresponse);
            setShowTrendingFilterResponseAllProductTable(true);
            setShowAllTrendingProductTable(false)
        }
    }

    const handleRemoveFilterDataResponse = () => {
        setShowFilterResponseAllProductTable(false);
        setShowAllProductTable(true)
    }

    const handleTrendingRemoveFilterDataResponse = () => {
        setShowTrendingFilterResponseAllProductTable(false);
        setShowAllTrendingProductTable(true)
    }

    const handlePageSize = (value) => {
        setPageSize(Number(value))
    }

    const handleAllProductLists = (data) => {
        console.log('data passed table to action', data)
    }

    const handleShowCreateEnquiresForm = () => {
        setShowCreateEnquiresForm(true)
        setUpdateRfq(null)
    }

    const handleChangeIcon = (value) => {
        if (changeIcon === 'Edit') {
            setChangeIcon(value)
        }
        else {
            setShowSavePopup(true)
            setChangeIcon(value)
            setTimeout(() => {
                setShowSavePopup(false)
            }, 1000)
        }
    }

    const handleUpdateRfq = (id) => {
        setUpdateRfq(id)
        setShowCreateEnquiresForm(true)
    }

    const handleRefreshTable = (tablename) => {
        if (tablename === 'All Products List') {
            setRefreshTable1(true);
            setTimeout(() => {
                setRefreshTable1(false);
            }, 2000);
        } else if (tablename === 'Trending Products') {
            setRefreshTable2(true);
            setTimeout(() => {
                setRefreshTable2(false);
            }, 2000);
        } else if (tablename === 'High Demands / Hot Enquires') {
            setRefreshTable3(true);
            setTimeout(() => {
                setRefreshTable3(false);
            }, 2000);
        }
    };

    const tabTitle =
  activeTab === 'all'
    ? 'All Products List'
    : activeTab === 'trending'
    ? 'Trending Products'
    : activeTab === 'highDemand'
    ? 'High Demands / Hot Enquires'
    : '';


    return (
           <div className="w-[80vw]">
            {/* Tabs for Categories */}
            <div className="flex items-center gap-7 px-8 mb-4 text-xl font-semibold text-gray-500">
                <div
                    className={`cursor-pointer ${activeTab === "all" ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}`}
                    onClick={() => { setActiveTab("all"); setChangeIcon('') }}
                >
                    All
                </div>
                <div
                    className={`cursor-pointer ${activeTab === "trending" ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}`}
                    onClick={() => { setActiveTab("trending"); setChangeIcon('') }}
                >
                    Trending Services
                </div>
                <div
                    className={`cursor-pointer ${activeTab === "highDemand" ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}`}
                    onClick={() => { setActiveTab("highDemand"); setChangeIcon('Edit') }}
                >
                    High Demand / Hot Enquiries
                </div>
            </div>

            {activeTab === "highDemand" && (
                <HighDemandEnquiriesBanner RfqSelectedIds={selectedIds} />
            )}

            {/* Header Section */}
            <div className="flex items-center justify-between py-3 px-7">
                <div className="flex items-center gap-10">
                    <div className="flex items-center gap-3 text-gray-500" >
                        <h1 className="text-xl font-semibold text-gray-500">{activeTab === 'all' ? 'All Services List' : activeTab === 'trending' ? 'Trending Services' : activeTab === 'highDemand' ? 'High Demands / Hot Enquires' : ''}</h1>
                        <span className="cursor-pointer" onClick={() => handleRefreshTable(tabTitle)}>{ <FontAwesomeIcon icon={faRotate}  />}</span>
                    </div>
                    <div>
                        {activeTab === 'highDemand' && (
                            <div className="cursor-pointer">
                                {changeIcon === 'Edit' ? (
                                    <div className="flex items-center text-lg gap-3 text-white bg-gray-950 px-3 py-1 rounded" onClick={() => handleChangeIcon('Save')}>
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                        <span>Edit</span>
                                    </div>
                                ) : (
                                    <div className="flex items-center text-lg gap-3 text-white bg-green-600 px-3 py-1 rounded" onClick={() => handleChangeIcon('Edit')}>
                                        <FontAwesomeIcon icon={faFloppyDisk} />
                                        <span>Save</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex items-center gap-[20px]">
                    {activeTab === 'highDemand' ? (<>
                        {changeIcon === 'Save' ? (
                            <div
                                className={`flex gap-3 bg-[#FF0000] text-white items-center px-3 py-2 rounded-lg font-semibold group`}
                                onClick={handleShowCreateEnquiresForm}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                <button className="group-hover:cursor-pointer">Create Enquires</button>
                            </div>) : (<></>)}
                    </>) : ''}
                    {activeTab === 'all' ? (
                        <div
                            className="flex gap-3 bg-blue-200 text-blue-700 items-center px-3 py-2 rounded-lg font-semibold group "
                            onClick={handleBulkImport}
                        >
                            <LuCloudDownload className="group-hover:cursor-pointer" />
                            <button className="group-hover:cursor-pointer">Bulk Import</button>
                        </div>
                    ) : ''}
                    <div
                        className={`flex gap-3 bg-blue-200 text-blue-700 items-center px-3 py-2 rounded-lg font-semibold group ${changeIcon === 'Edit' ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-default'}`}
                        onClick={handleBulkExport}
                    >
                        <LuCloudUpload className={`${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`} />
                        <button className={`${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`}>Bulk Export</button>
                    </div>
                    {/* Pagination */}
                    <div className={`border border-gray-300 border-collapse rounded-lg text-gray-500 flex items-center ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'}`}>
                        <div className={`py-1 px-2 ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} border-r border-gray-300 ${pageSize === 20 ? 'bg-blue-600 text-white rounded-l-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>20</div>
                        <div className={`py-1 px-2 ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} border-r border-gray-300 ${pageSize === 100 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>100</div>
                        <div className={`py-1 px-2 ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} border-r border-gray-300 ${pageSize === 500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>500</div>
                        <div className={`py-1 px-2 ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} border-r border-gray-300 ${pageSize === 2500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>2500</div>
                        <div className={`py-1 px-2 ${changeIcon === 'Edit' ? 'opacity-50 group-hover:cursor-not-allowed' : 'opacity-100 group-hover:cursor-pointer'} ${pageSize === 5000 ? 'bg-blue-600 text-white rounded-r-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>5000</div>
                    </div>
                </div>
            </div>

             {/* Actions Section */}
            <AllServicesActionsSection
                onSelectColumns={handleColumnsSelection}

                onSelectedIds={[1,2,3]}
                onRfqSelectedIds={rfqSelectedIds}

                onSuccess={handleSuccess}

                onColumnSearch={handleColumnSearch}
                onRfqColumnSearch={handleRfqColumSearch}

                onGroupByResponse={handleGroupByResponse}
                onRemoveGroupBy={handleRemoveGroupBy}
                onTrendingGroupByResponse={handleTrendingGroupByResponse}
                onTrendingRemoveGroupBy={handleTrendingRemoveGroupBy}

                onFilteredData={handleFilterDataResponse}
                onRemoveFilters={handleRemoveFilterDataResponse}
                onTrendingFilteredData={handleTrendingFilterDataResponse}
                onTrendingRemoveFilters={handleTrendingRemoveFilterDataResponse}

                onAllProductsList={handleAllProductLists}
                onActionsModify={activeTab}
                onChangeIcon={changeIcon}
            />

            {/* Tables Based on Active Tab */}
            <div>
                {activeTab === "all" && (
                    <>
                        {showAllProductTable && (
                            <AllServicesTable
                                onSelectColumns={selectedColumns}
                                onSelectedIds={handleSelectedIds}
                                onSuccess={successStatusUpdate}
                                onColumnSearch={columnSearch}
                                onRefresh={refreshTable1}
                                onPageSize={pageSize}
                                onReturnPageSize={(value) => setPageSize(value)}
                            />
                        )}
                    </>
                )}
                {activeTab === "trending" && (
                    <>
                        {showAllTrendingProductTable && (
                            <AllTrendingServicesTable
                                onSelectColumns={selectedColumns}
                                onSelectedIds={handleSelectedIds}
                                onSuccess={successStatusUpdate}
                                onColumnSearch={columnSearch}
                                onRefresh={refreshTable2}
                                onPageSize={pageSize}
                                onReturnPageSize={(value) => setPageSize(value)}
                            />
                        )}
                    </>
                )}

                {activeTab === "highDemand" && (
                        <AllRfqTable
                            onSelectColumns={selectedColumns}
                            onRfqSelectedIds={handleSelecteRfqdIds}
                            onSuccess={successRfq}
                            onRfqColumnSearch={rfqcolumnSearch}
                            onRefresh={refreshTable3}
                            onPageSize={pageSize}
                            onReturnPageSize={(value) => setPageSize(value)}
                            onUpdate={(id) => handleUpdateRfq(id)}
                            onChangeIcon={changeIcon}
                        />
                )}

                {ShowFilterResponseAllProductTable && (<FiltersTable Data={filterDataResponse} onSelectColumns={selectedColumns}
                    onSelectedIds={handleSelectedIds}
                    onSuccess={successStatusUpdate}
                    onColumnSearch={columnSearch} />)}

                {ShowTrendingFilterResponseAllProductTable && (<FiltersTable Data={trendingFilterDataResponse} onSelectColumns={selectedColumns}
                    onSelectedIds={handleSelectedIds}
                    onSuccess={successStatusUpdate}
                    onColumnSearch={columnSearch} />)}

                {ShowGroupByResponseAllProductTable && (<GroupByResponseTable Data={groupByResponse} />)}
                {ShowTrendingGroupByResponseAllProductTable && (<GroupByResponseTable Data={trendingGroupByResponse} />)}
            </div>
            
            {/* Popup Section */}
            {showBulkImportAllProducts && (<BulkImportServiceModal closeModal={() => setShowBulkImportAllProducts(false)} />)}
            {showBulkExportAllProducts && (<BulkExportAllServices onActiveTab={activeTab} />)}
            {showCreateEnquiresForm && (<CreateRfqModal onClose={() => setShowCreateEnquiresForm(false)} onSuccess={handleRfqSuccess} onUpdate={updateRfq} />)}
            {showSavePopup && (<SavePopup onClose={() => setShowCreateEnquiresForm(false)} onSuccess={handleRfqSuccess} />)}
        </div>

        
    );
};

export default AllServices;